/* @flow */
/**
 * External dependencies
 */
import React, { Component } from 'react';

/**
 * Internal dependencies
 */
import { getWindowWidth, getWindowHeight } from '../../utils/window';

/**
 * Style
 */
import {
	FullScreenPlayer,
} from './style';

/**
 * Flow
 */
type VideoProps = {
	url: null | string,
	background: null | string,
};

type VideoState = {
	height: null | number | 'auto',
	width: null | number | 'auto',
	playing: boolean,
	video: boolean,
};

const VIDEO_RATIO = 1.7777777778; // 960x540px

class Video extends Component<VideoProps, VideoState> {
	videoRef: any;

	constructor( props: VideoProps ) {
		super( props );

		this.videoRef = React.createRef();

		this.state = {
			height: null,
			width: null,
			playing: false,
			video: true,
		};
	}

	componentDidMount() {
		window.addEventListener( 'resize', this.handleResize );
		this.handleResize();

		if ( this.videoRef && this.videoRef.current ) {
			this.videoRef.current.muted = true;
			const promise = this.videoRef.current.play();

			if ( promise !== undefined ) {
				promise.catch( () => {
					// If video don't start we want to show a image.
					this.setState( { video: false } );
				} );
			}
		}
	}

	componentWillUnmount() {
		window.removeEventListener( 'resize', this.handleResize );
	}

	handleResize = () => {
		this.setState( {
			height: this.getHeight(),
			width: this.getWidth(),
		} );
	}

	getWindowRatio() {
		return getWindowHeight() / getWindowWidth();
	}

	getHeight() {
		return this.getWindowRatio() <= VIDEO_RATIO ? 'auto' : getWindowHeight();
	}

	getWidth() {
		return this.getWindowRatio() > VIDEO_RATIO ? 'auto' : getWindowWidth();
	}

	render() {
		const {
			height,
			width,
		} = this.state;

		const {
			url,
		} = this.props;

		return (
			<div>
				<FullScreenPlayer isMainWindow isIntro>
					{ this.state.video && this.props.url && (
						<video
							ref={ this.videoRef }
							className="video-frame"
							controlsList="nodownload"
							muted="1"
							loop
							playsInline
							poster={ this.props.background }
							style={ {
								height,
								width,
							} }
						>
							<source src={ url } type="video/mp4" />
						</video>
					) }

					{ ( ( ! this.state.video && this.props.background ) || ( ! url && this.props.background ) ) && (
						<div className="image-frame" style={ { backgroundImage: `url(${ this.props.background })` } } />
					) }
				</FullScreenPlayer>
			</div>
		);
	}
}

export default Video;



// WEBPACK FOOTER //
// ./src/views/video/introVideo.js